import React from 'react';
import Modal from '~/app/common/Modal';
import classes from './style.module.scss';
import Button from "~/app/common/Button";
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '../Icon';

export type TextDialogProps = {
    isOpen?: boolean,
    onClose?(): void,
    text: string
}

export type TextDialogComponent = React.FC<TextDialogProps>

const TextDialog: TextDialogComponent = ({ isOpen = false, onClose, text }) => {
    const { t } = useTranslation('common.confirmActions');

    return (
        <Modal className={classes['text-dialog']} open={isOpen} position={'center'}>
            <div className={classes['modal-body']}>
                <div className={classes['header-content']}>
                    <label className={classes['text']}>{text}</label>
                </div>
                <Button className={`${[classes['action-btn']]} ${classes['close-btn']}`} onClick={onClose}>
                    <span className={classes['close-text']}>
                        <Icon name='close' className={classes['close-icon']} />
                        <span>{t('cancel')}</span>
                    </span>
                </Button>
            </div>
        </Modal>
    );
};

export default TextDialog;
